/**
 * quote-cart.js
 * Athletic Textiles — Quote Cart System
 * Stores quote items in localStorage, provides badge count update
 */

(function() {

  var STORAGE_KEY = 'at_quote_cart';

  /* ── Read / Write ── */
  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateBadge(items.length);
    window.dispatchEvent(new CustomEvent('quoteCartUpdated', { detail: items }));
  }

  /* ── Add item ── */
  function addItem(item) {
    var items = getItems();
    item.id   = Date.now().toString();
    item.added = new Date().toLocaleString();
    items.push(item);
    saveItems(items);
    return item;
  }

  /* ── Remove item ── */
  function removeItem(id) {
    var items = getItems().filter(function(i) { return i.id !== id; });
    saveItems(items);
  }

  /* ── Clear all ── */
  function clearAll() {
    saveItems([]);
  }

  /* ── Update badge ── */
  function updateBadge(count) {
    var badge = document.getElementById('quoteCartCount');
    if (!badge) return;
    badge.textContent = count;
    var btn = document.getElementById('quoteCartBtn');
    if (btn) {
      btn.style.display = count > 0 ? 'inline-block' : 'inline-block'; // always show
    }
    /* Pulse animation on add */
    if (badge.parentElement) {
      badge.parentElement.classList.add('quote-badge-pulse');
      setTimeout(function() {
        badge.parentElement.classList.remove('quote-badge-pulse');
      }, 600);
    }
  }

  /* ── Init badge on page load ── */
  function init() {
    var items = getItems();
    updateBadge(items.length);
  }

  /* ── Public API ── */
  window.QuoteCart = {
    add:     addItem,
    remove:  removeItem,
    clear:   clearAll,
    items:   getItems,
    count:   function() { return getItems().length; }
  };

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
